export default "__VITE_ASSET__BkeYlayr__"